import { EOS_FLAG } from './constants';
export function isNewLine(c) {
    return c === '\r' || c === '\n';
}
export function isWhitespace(c) {
    return c === ' ' || c === '\t' || c === '\n';
}
export function isAlpha(c) {
    return !!c.match(/[a-z]/i);
}
export function isNumber(c) {
    if (c === EOS_FLAG) {
        return false;
    }
    return !isNaN(parseFloat(c)) && isFinite(parseInt(c, 10));
}
export function isIdent(c) {
    if (c === EOS_FLAG) {
        return false;
    }
    return isAlpha(c) || isNumber(c) || c === '_' || c === '-' || c === '\\';
}
export function isTerminator(c) {
    return c === EOS_FLAG || isWhitespace(c) || c === ',' || c === ']' || c === ')';
}
//# sourceMappingURL=strings.js.map